import type { ICourseDto, ICourseGetAllParams, ICourseResponse } from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createDeleteApi } from "@api/util/createDeleteApi";
import { accessCodes } from "@api/courses/accessCodes/api";
import { sessions } from "@api/courses/sessions/api";
import { contents } from "@api/courses/contents/api";
import { reviews } from "@api/courses/reviews/api";
import { exams } from "@api/courses/exams/api";
import { enrollments } from "@api/courses/enrollments/api";
import { stats } from "@api/courses/stats/api";
import { reviewStats } from "@api/courses/reviewStats/api";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ICourseResponse>>,
  IPathBaseParam,
  IPaginationParams & ICourseGetAllParams
>("courses");
const postApis = createPostApi<
  IApiResponse<ICourseResponse>,
  IPathBaseParam,
  ICourseDto
>("courses");
const getApis = createGetApi<
  IApiResponse<ICourseResponse>,
  IPathByIdParam,
  object
>("courses");
const patchApis = createPatchApi<
  IApiResponse<ICourseResponse>,
  IPathByIdParam,
  ICourseDto
>("courses");
const deleteApis = createDeleteApi<
  IApiResponse<ICourseResponse>,
  IPathByIdParam
>("courses");

export const courses = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
  accessCodes,
  sessions,
  contents,
  reviews,
  exams,
  enrollments,
  stats,
  reviewStats,
};
